var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"list-unstyled brand-links small mb-0 d-flex flex-column flex-md-row text-center"},_vm._l((_vm.links),function(ref){
var href = ref[0];
var text = ref[1];
return _c('li',{key:href},[_c('a',{attrs:{"href":href}},[_vm._v(_vm._s(text))])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }